// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1oSgw","signatureButtonsRight":"ModalSign_signatureButtonsRight__1LZNh"};